import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import HomeContainer from './view/home-container';
import {
  ContentsPage,
  PrivacyPolicy,
  TermsService,
  TestPage,
  CampaignPage,
} from './pages';
import { ScrollToTop } from './components/common';
import PageMeta from './components/common/PageMeta';
import { theme } from './styles/theme';
import { GlobalStyle } from './styles/GlobalStyle';
import { DialogProvider } from './components/ui/DialogProvider';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <DialogProvider>
        <Router>
          <PageMeta />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomeContainer />} />
            <Route path="/contents" element={<ContentsPage />} />
            <Route path="/campaigns" element={<CampaignPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms-service" element={<TermsService />} />
            <Route path="/test" element={<TestPage />} />
            {/* <Route path="/account-delete" element={<AccountDelete />} /> */}
          </Routes>
        </Router>
      </DialogProvider>
    </ThemeProvider>
  );
}

export default App;
